import React from "react";
import proptypes from "prop-types";
import { Typography } from "@one-thd/sui-atomic-components";
import { TooltipContent } from "./tooltip-content";

const { bool, shape, string } = proptypes;

export const AvailabilityTooltipContent = ({
  showMainTooltip,
  showUnavailableTooltip,
  shouldShowOOSTTooltip,
  hoveredCombinationDetails,
  unavailableTooltipMessage,
  oosTooltipMessage
}) => {
  if (showMainTooltip) {
    return <TooltipContent hoveredCombinationDetails={hoveredCombinationDetails} />;
  }
  if (shouldShowOOSTTooltip) {
    return (
      <Typography variant="body-base" align="center">{oosTooltipMessage}</Typography>
    );
  }
  
  if (showUnavailableTooltip) {
    return (
      <Typography variant="body-base" align="center">
        {unavailableTooltipMessage}
      </Typography>
    );
  }
  return null;
};

AvailabilityTooltipContent.propTypes = {
  showMainTooltip: bool,
  showUnavailableTooltip: bool,
  shouldShowOOSTTooltip: bool,
  hoveredCombinationDetails: shape({}),
  unavailableTooltipMessage: string,
  oosTooltipMessage: string
};

AvailabilityTooltipContent.defaultProps = {
  showMainTooltip: false,
  showUnavailableTooltip: false,
  shouldShowOOSTTooltip: false,
  hoveredCombinationDetails: {},
  unavailableTooltipMessage: "",
  oosTooltipMessage: "",
};
